import { LicensesBackInitModel } from '../../../../../app/pages/licenses-buy-product/shared/model';
import { FormPropertyModel } from './form-property.model';

export class FormConfigurationModel {
    formProperty: FormPropertyModel [];
}

export class TextFormModel {
    label: string;
    elementType='text';
    placeHolder?: string;
    formControlName: string;
    initialValue?: string;
    altText: string;
    toolTipText: string;
    numberOnly?: false;
    validation: {
        required: boolean;
        pattern?: string;
        minLength?: number;
        maxLength?: number;
        errorMessages: {
            required: string;
            pattern?: string;
            minLength?: number;
            maxLength?: number;
        }
    };
    showOrder?: number;
    constructor(name: string) {
        this.label=name;
        this.altText=name;
        this.formControlName=name;
        this.label=name;
        this.toolTipText=name;
        this.validation={required:true,errorMessages:{required: name+' is requred!'}}
    }
}